// extracted by mini-css-extract-plugin
export default {"tableGeneral":"PatientTables_tableGeneral__0FVg4","container":"PatientTables_container__LLdeP","tablesContainer":"PatientTables_tablesContainer__7S9Vm"};